import { humanizeString } from "@/utils/frontend/stringOps";
import AvatarImage from "../Molecules/AvatarImage";
import Link from "next/link";
import { dateFormat_0, dateFormat_1, dateFormat_3 } from "@/utils/frontend/dateOps";
import MessageSmallCard from "./Cards/Social/MessageSmallCard";

const EventTimeline = ({ events }) => {
  if (!events || events.length === 0) 
    return <p className="text-gray-500">No events yet.</p>;

  return (
    <div className="relative ml-6">
      {events.map((event, index) => {
        const isLast = index === events.length - 1;

        return (
          // <div key={event.event_date} className="relative flex space-x-3 mb-6">
          <div key={event.event_date} className="relative flex space-x-3 mb-6">

            {/* Dot */}
            <div className="flex flex-col items-center">
              <div className="w-full whitespace-nowrap px-4 flex items-center justify-center h-5 bg-teal-400 rounded-full z-10 text-slate-100 text-xs">{humanizeString (event.event_type)}</div>
              {/* Line */}
              {!isLast && (
                <div className="absolute top-3 left-2 h-3/4 w-px bg-slate-200 dark:bg-slate-700"></div>
              )}
            </div>

            {/* Content */}
            {/* <div className="flex-1 bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
              <div className="flex items-center space-x-2">
                <AvatarImage background={false} module={'USER'} data={event.event_user_data} size="xs" />
                <Link href={`/@${event.event_user_data.user_handle}`} className="text-gray-800 dark:text-slate-50 font-ubuntu text-base">
                  {event.event_user_data?.user_first_name || 'Deleted'}{' '}
                  {event.event_user_data?.user_last_name || ''}
                </Link>

                <span className="text-sm text-gray-500 ml-2">
       
                  {new Date(event.event_date).toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  year: 'numeric'
                })}

                </span>
              </div>


 {event.event_message_content && <div className="mt-1 text-sm text-slate-600 dark:text-slate-100">
     {event.event_message_content}</div>}
      
            </div> */}
            <MessageSmallCard data={event} parentComponent={'SUBMISSIONS'}/>
          </div>
        );
      })}
    </div>
  );
};

export default EventTimeline;











// v1

// import AvatarImage from "../Molecules/AvatarImage";


// const EventTimeline = ({ events }) => {
//   if (!events || events.length === 0) return <p className="text-gray-500">No events yet.</p>;

//   return (
//     <div className="flex flex-col space-y-4">
//       {events.map(event => (
//         <div key={event.event_date} className="flex items-start space-x-3">
//           {/* Vertical line */}
//           <div className="flex flex-col items-center">
//             <div className="w-3 h-3 bg-teal-500 rounded-full mt-2"></div>
//             <div className="flex-1 w-px bg-gray-300"></div>
//           </div>

//           {/* Content */}
//           <div className="flex-1 bg-gray-50 rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow duration-200">
//             <div className="flex items-center space-x-2">
//               {/* Avatar */}
//               <AvatarImage module={'USER'} data={event.event_user_data} size='xs'/>
//               {/* <img
//                 src={event.event_user_data?.user_avatar || '/default-avatar.png'}
//                 alt={event.event_user_data?.user_first_name || 'User'}
//                 className="w-8 h-8 rounded-full object-cover"
//               /> */}
//               <span className="font-semibold text-gray-800">
//                 {event.event_user_data?.user_first_name || 'Deleted'}{' '}
//                 {event.event_user_data?.user_last_name || ''}
//               </span>
//               <span className="text-sm text-gray-500 ml-2">
//                 {event.event_type.replace('_', ' ')}
//               </span>
//             </div>

//             <div className="mt-1 text-sm text-gray-600">
//               {new Date(event.event_date).toLocaleString('en-US', {
//                 month: 'short',
//                 day: 'numeric',
//                 hour: '2-digit',
//                 minute: '2-digit',
//               })}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default EventTimeline;